import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./baseQuery";

/**
 * Help and Support configuration.
 *
 * The response is audience-specific and resolved server-side from the session — members
 * receive the KEPRO Desk widget configuration, KEPRO staff receive the Mediacent ticket
 * link. The client never asks for one or the other, and must not try to: the audience is
 * not a request parameter, precisely so a member cannot obtain the staff destination.
 *
 * Uses baseQueryWithAuth rather than a hand-rolled fetchBaseQuery so it inherits the
 * shared session-expiry handling.
 */
export const supportApi = createApi({
  reducerPath: "supportApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Support"],
  endpoints: (builder) => ({
    getSupportConfig: builder.query({
      query: () => ({ url: "/support/config" }),
      providesTags: ["Support"],
      // Static per session; refetching on every mount would add a request to each page
      // that renders the support button — which is every page with a NavBar.
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useGetSupportConfigQuery } = supportApi;
